import React, { KeyboardEventHandler, useEffect, useState } from 'react';

import CreatableSelect from 'react-select/creatable';
import { ActionMeta, OnChangeValue } from 'react-select';
import { createOption, OptionType } from './interfaces';

interface Props {
    label: string;
    name: string;
    options: Array<string>;
    selectedOption: string | undefined;
    error: string | number | undefined;
    required: boolean;
    onChange: ({ currentTarget }: { currentTarget: { name: string; value: string } }) => void;
}

const SelectWithCustomInput = (props: Props): JSX.Element => {
    const {
        label,
        name,
        required,
        error,
        onChange,
        options: retrievedOptions,
        selectedOption: previouslySelectedOption
    } = props;

    const [options, setOptions ] = useState<Array<OptionType>>([]);
    const [ selectedOption, setSelectedOption ] = useState<OptionType>();

    useEffect(() => {
        const newOptions = new Array<OptionType>();
        retrievedOptions.forEach((retrievedOption: string) => {
            newOptions.push(createOption(retrievedOption));
        });
        previouslySelectedOption && setSelectedOption(createOption(previouslySelectedOption));
        setOptions(newOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let value;
        if (selectedOption) {
            value = selectedOption.label
        } else {
            value = '';
        }
        const currentTarget = {
            name,
            value
        };
        onChange && onChange({ currentTarget });
    }, [selectedOption, name, onChange]);

    const handleChange = (newValues: OnChangeValue<OptionType, false>, actionMeta: ActionMeta<OptionType>): void => {
        if (actionMeta.action === "create-option") {
            const newOptions = [...options];
            const newlyCreatedOption = createOption(actionMeta.option.value);
            newOptions.push(newlyCreatedOption);
            setOptions(newOptions);
        }
        setSelectedOption(newValues || undefined);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (event: any) => {
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                event.preventDefault();
        }
    };
    return (<React.Fragment>
        <div className="form-group">
            {
                label && (<label htmlFor={name} className="text-small no-padding">
                    {label}
                    {required && <span className="required">*</span>}
                </label>)
            }
            <CreatableSelect
                isMulti={false}
                onChange={handleChange}
                options={options}
                value={selectedOption}
                onKeyDown={handleKeyDown}
                isClearable={!required}
            /> {error && <div className="alert alert-danger">{error}</div>}
        </div>
    </React.Fragment>
    );
};

export default SelectWithCustomInput;
